export const PRICE                        = 'home_price';
export const DOWN_PAYMENT                 = 'down_payment_amount';
export const DOWN_PERCENT                 = 'down_payment_percent';
export const MORTGAGE_PERCENT             = 'mortgage_percent';
export const PROPERTY_TAX                 = "property_tax";
export const HOME_INSURANCE               = "home_insurance";
export const PRINCIPAL_INTEREST           = "principle_interest";
export const MORTGAGE_INSURANCE           = "mortgage_insurance";
export const MORTGAGE_INSURANCE_FIELD     = "mortgage_insurance_field";
export const HOA_FEES                     = "hoa_fees";
export const ERROR_LABEL                  = 'pmytoptions-homeprice-err';
export const MORTGAGE_PERCENT_ERROR_LABEL = 'pmytoptions-mortgamt-err';
export const MONTHLY_PAYMENT              = "rent_per_month";
export const TYPE                         = "mortgage_loan_type";
export const BENEFITS                     = "apply-benefits";
export const MOBILE_SENTENCE_DP_PERCENT = "#mobile-sentence-dp-percent";
export const MOBILE_SENTENCE_LOAN_TYPE = "#mobile-sentence-loan-type";
export const MOBILE_SENTENCE_MRTG_PERCENT = "#mobile-sentence-mrtg-percent";
// not sure why this is called veterans checkbox
export const PRE_APPROVED                 = "veterans-checkbox";


export const CHANGE      = "calculator.field.change";
export const WAS_CHANGED = "calculator.field.changed";
export const SIDE_EFFECT = "calculator.field.side.effect";

export const ERROR        = "calculator.field.error";
export const CLEAR_ERRORS = "calculator.field.errors.clear";
export const SYNC_BOUND   = "calculator.field.sync.bound.fields";

export const PERCENT          = "%";
export const HIGHLIGHT_FIELDS = "highlight-fields";
export const BLANK            = "";


// local storage keys
export const BENEFITS_STORE_KEY         = "local_stored_veterans_checked";
export const DOWN_PERCENT_STORE_KEY     = "local_stored_estimate_dp_percent";
export const DOWN_PAYMENT_STORE_KEY     = "local_stored_estimate_dp_amount";
export const TYPE_STORE_KEY             = "local_stored_selected_mortgage_type";
export const MORTGAGE_PERCENT_STORE_KEY = "local_stored_mortgage_percent";

export const PRICE_MIN = 1000;
export const PRICE_MAX = 999999999;



// WEBPACK FOOTER //
// ./quick_view/components/payment/constants/index.js